import { useRef, useState } from "react";
import { MagnifyingGlassPlus } from "@phosphor-icons/react";

export default function HoverMagnifier({ src, alt, onOpen }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(null);
  const canHover = typeof window !== "undefined" && window.matchMedia?.("(hover: hover) and (pointer: fine)").matches;

  function move(e) {
    if (!canHover) return;
    const r = ref.current.getBoundingClientRect();
    setPos({ x: ((e.clientX - r.left) / r.width) * 100, y: ((e.clientY - r.top) / r.height) * 100 });
  }

  return (
    <button type="button" ref={ref} data-testid="product-main-image" onClick={onOpen} onMouseMove={move} onMouseLeave={() => setPos(null)}
      aria-label="Open full-screen zoom" className="group relative w-full h-full overflow-hidden cursor-zoom-in">
      <img src={src} alt={alt} draggable={false}
        style={pos ? { transform: "scale(2.2)", transformOrigin: `${pos.x}% ${pos.y}%` } : undefined}
        className="w-full h-full object-cover transition-transform duration-200 ease-out" />
      <span className="absolute bottom-3 right-3 bg-white/90 backdrop-blur-md text-[#1C211E] text-[10px] uppercase tracking-widest px-2.5 py-1.5 rounded-sm flex items-center gap-1.5 opacity-80 group-hover:opacity-100 transition-opacity pointer-events-none">
        <MagnifyingGlassPlus size={12} /> {canHover ? "Hover to zoom · click for full screen" : "Tap to zoom"}
      </span>
    </button>
  );
}
